<template>
    <div class="dynamic">
        <transition name="slide-left" >
			<router-view class="child-view" /> 
		</transition>
    </div>
</template>
<script>

export default {
    name: "dynamicIndex"
}
</script>
<style>
.dynamic{
	width:100%;
	height:100%;
}
</style>